// Feature flags for gradual rollout of new features
export const FEATURE_FLAGS = {
  // Pairwise ranking system - Beli-style benchmarking
  PAIRWISE_RANKING: true, // Set to false to disable entirely
  
  // Debug mode - shows additional diagnostics
  PAIRWISE_DEBUG: false, // Enable with ?debug=1 in URL
  
  // Bookshelf scanner - AI-powered book extraction from photos
  BOOKSHELF_SCANNER: true, // Set to false to disable if costs too high
} as const;

export const isFeatureEnabled = (feature: keyof typeof FEATURE_FLAGS): boolean => {
  // Check URL params for debug mode override
  if (feature === 'PAIRWISE_DEBUG') {
    const params = new URLSearchParams(window.location.search);
    return params.get('debug') === '1' || FEATURE_FLAGS[feature];
  }
  
  return FEATURE_FLAGS[feature];
};

export const getDebugInfo = () => {
  if (!isFeatureEnabled('PAIRWISE_DEBUG')) return null;
  
  return {
    pairwiseEnabled: isFeatureEnabled('PAIRWISE_RANKING'),
    debugMode: isFeatureEnabled('PAIRWISE_DEBUG'),
    url: window.location.href,
    timestamp: new Date().toISOString(),
  };
};